import axios, { AxiosPromise } from 'axios';
import { IGetGaDevice, IGetGaSite, IGetGaUser } from '../models/ga.model';

const uri = '/mgmt/ga';

export const getGaDevice = (): AxiosPromise<IGetGaDevice> =>
  axios.get(`${uri}/device`);

export const getGaUser = (): AxiosPromise<IGetGaUser> =>
  axios.get(`${uri}/user`);

export const getGaSite = (): AxiosPromise<IGetGaSite> =>
  axios.get(`${uri}/site`);
